
import { Base } from '../base-component';
import './bizconnect.component.scss';

export class Bizconnect extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/bizconnect/bizconnect.component.ts